export function getProductNews(product) {
  return fetch(`${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_API_VERSION}/newsfeed/summary?tags=${product}&limit=3`)
    .then((resp) => resp.json())
    .then((resp) => resp);
}